import * as focusTrap from 'focus-trap';
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';

const selectors = {
  openFilters: '[data-filter-drawer-toggle]',
  closeFilters: '[data-filter-drawer-close]',
  overlay: '[data-filter-overlay]',
  backdrop: '[data-filter-backdrop]',
  drawer: '[data-filter-drawer]',
  filterForm: '[data-filter-form]',
};

export default class MobileFilterDrawer {
  /**
   * @param {HTMLElement} [root] - Optional root element to search within (e.g. section element). If not provided, uses document.
   */
  constructor(root = null) {
    this.el = (root || document).querySelector(selectors.filterForm);
    if (!this.el) return;

    this.overlay = this.el.querySelector(selectors.overlay);
    this.drawer = this.el.querySelector(selectors.drawer);
    if (!this.overlay || !this.drawer) return;

    this._init();

    this.focusTrap = focusTrap.createFocusTrap(selectors.overlay, {
      onActivate: () => {
        this.el.classList.add('focus-trap');
      },
      onDeactivate: () => {
        this.el.classList.remove('focus-trap');
      },
      initialFocus: () => this.drawer,
      clickOutsideDeactivates: true,
    });
  }

  _init = () => {
    const openFilters = this.el.querySelector(selectors.openFilters);

    if (openFilters) {
      openFilters.addEventListener('click', () => {
        this._openDrawer();
      });
    }

    const closeFilters = this.el.querySelectorAll(selectors.closeFilters);

    if (closeFilters) {
      closeFilters.forEach(filter => {
        filter.addEventListener('click', () => {
          this._closeDrawer();
        });
      });
    }

    const backdrop = this.overlay.querySelector(selectors.backdrop);

    if (backdrop) {
      backdrop.addEventListener('click', () => {
        this._closeDrawer();
      });
    }
  };

  _openDrawer = () => {
    this.overlay.classList.add('is-open');
    document.body.classList.add('filter-drawer-open');
    disablePageScroll();
    this.focusTrap.activate();
  };

  _closeDrawer = () => {
    this.overlay.classList.remove('is-open');
    document.body.classList.remove('filter-drawer-open');
    enablePageScroll();
    this.focusTrap.deactivate();
  };
}
